import { useState } from "react";

export default function FImg({ src, h = 160, style = {}, alt = "", placeholder = "" }) {
  const [ok, setOk] = useState(true);
  if (!src || !ok) {
    // Picsum deterministic placeholder based on alt text hash
    const seed = placeholder || (alt ? alt.split(' ').map(w => w[0]).join('').toLowerCase() : 'img');
    const pw = typeof style.width === 'number' ? style.width : 400;
    const ph = h;
    const purl = `https://picsum.photos/seed/${encodeURIComponent(seed)}/${pw}/${ph}`;
    return (
      <div style={{ height: h, position: "relative", overflow: "hidden", ...style }}>
        <img src={purl} alt={alt || "placeholder"} style={{ width: "100%", height: "100%", objectFit: "cover", filter: "brightness(.85) saturate(.7)" }} onError={e => { e.target.style.display = "none"; }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg,rgba(26,60,110,.45),rgba(15,107,86,.3))", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: Math.min(h * .25, 36), opacity: .7 }}>{placeholder || "🖼️"}</span>
        </div>
      </div>
    );
  }
  return <img src={src} alt={alt} onError={() => setOk(false)} style={{ width: "100%", height: h, objectFit: "cover", ...style }} />;
}
